module.exports = __webpack_public_path__ + "assets/img/AstonRX-Landing-Page-w720.ce6251a6.webp";